import { createAction } from "@reduxjs/toolkit";
import { SetUserPlanDurationDto } from "models/SetUserPlanDuration";
export const getUsersForTestCronAction = createAction("getUsersForTestCronAction");
export const initUsersForTestCronAction = createAction("initUsersForTestCronAction");
export const clearUsersForTestCronAction = createAction("clearUsersForTestCronAction");

export const triggerCronAction = createAction<SetUserPlanDurationDto>("triggerCronAction");
